export default "__VITE_ASSET__CipxeV7Y__"